import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {
  isMemberAbleToFinishRsvp,
  resolveButtonTextTranslation,
  resolveStatusTextTranslation,
} from '../../../selectors/member-rsvp'
import {RsvpInfoButton} from '../rsvp-info-button/rsvp-info-button'

export const EditRegistrationButton: React.FC = () => {
  const {t} = useTranslation()
  const {changeMemberRsvp, openConfirmRsvp} = useAppActions()

  const messageTranslation = useAppSelector(resolveStatusTextTranslation)
  const buttonTextTranslation = useAppSelector(resolveButtonTextTranslation)
  const memberAbleToFinishRsvp = useAppSelector(isMemberAbleToFinishRsvp)

  const handleClick = () => {
    if (memberAbleToFinishRsvp) {
      openConfirmRsvp()
    } else {
      changeMemberRsvp(hookToAttributeSelector(DH.RSVP_INFO_BUTTON))
    }
  }

  return (
    <RsvpInfoButton
      messages={{
        exploreEventsActionLabel: t(buttonTextTranslation),
        message: t(messageTranslation),
      }}
      dataHook={DH.UPDATE_MEMBER_EVENT}
      onClick={handleClick}
    />
  )
}
